<template>
    <div class="asset-center">
        <div class="title-with-icon">
            <img src="@/assets/images/shop-manage/icon-shop-manage-asset-center.png" alt="" class="icon" />
            资产中心
        </div>
        <div class="account-preview-box">
            <div class="title-no-icon">账户总览</div>
            <div class="balance-item-box">
                <div class="balance-item">
                    <div class="item-title">可提现金额</div>
                    <div class="item-value">¥{{shopInfo.withdrawable_money|price_format}}</div>
                    <div class="item-tips">
                        金额增减详情可查看<span @click="onShowLog(1)">支付账户</span>、<span @click="onShowLog(2)">店铺账户</span>收支明细
                    </div>
                    <div v-if="false" class="withdrawal-btn">提现</div>
                </div>
                <div class="balance-item">
                    <div class="item-title">总金额</div>
                    <div class="item-value">¥{{shopInfo.total_asset|price_format}}</div>
                </div>
                <div class="balance-item">
                    <div class="item-title">待结算金额</div>
                    <div class="item-value">¥{{shopInfo.shop_unsettle_money || 0|price_format}}</div>
                </div>
            </div>
        </div>
        <div class="account-box">
            <div class="account-item">
                <div class="item-title-box">
                    <div class="item-title">支付账户</div>
                    <div class="item-btn">
                        <span @click="onShowCardInfo">绑卡详情</span>
                        <span @click="onShowLog(1)">账户明细</span>
                    </div>
                </div>
                <div class="item-sub-title">账户余额</div>
                <div class="item-money">¥{{shopInfo.total_balance|price_format}}</div>
                <div class="btn-box">
                    <div class="withdrawal-btn" @click="showWithdraw(1)">提现</div>
                    <div class="recharge-btn" @click="show_charge_pop=true">充值</div>
                </div>
            </div>
            <div class="account-item">
                <div class="item-title-box">
                    <div class="item-title">店铺账户</div>
                    <div class="item-btn">
                        <span @click="onShowCardInfo">绑卡详情</span>
                        <span @click="onShowLog(2)">账户明细</span>
                    </div>
                </div>
                <div class="item-sub-title">账户余额</div>
                <div class="item-money">¥{{shopInfo.shop_balance|price_format}}</div>
                <div class="btn-box">
                    <div class="withdrawal-btn" @click="showWithdraw(2)">提现</div>
                </div>
            </div>
        </div>
        <balance-charge v-if="show_charge_pop" @close-charge-pop="()=>show_charge_pop=false" @on-charge-success="onChargeSuccess"></balance-charge>
        <charge-success v-if="show_charge_success" @close-charge-success="()=>show_charge_success=false" :amount="temp_charge_amount"></charge-success>
    </div>
</template>
<script> 
import BalanceCharge from '@/components/BalanceCharge';
import ChargeSuccess from '@/components/ChargeSuccess';
import { mapState } from 'vuex';
export default{
    name:"AssetCenter",
    data() {
        return {
            show_charge_pop:false,
            show_charge_success:false,
            temp_charge_amount:'',
        }
    },
    components:{
        BalanceCharge,
        ChargeSuccess
    },
    computed:{
        ...mapState({
            shopInfo:state=>state.shopInfo
        })
    },
    mounted(){},
    methods:{
        onShowCardInfo(){
            this.$emit('show-card');
        },
        onChargeSuccess({amount}){
            console.log('on-charge-success',amount);
            this.temp_charge_amount = amount
            this.show_charge_pop = false;
            this.show_charge_success = true;
        },
        showWithdraw(type){
            this.$emit('show-withdraw',{type});
        },
        onShowLog(type){
            this.$emit('show-log',{type})
        }
    }
}
</script>
<style lang="scss" scoped>
.asset-center{
    width:100%;
    padding:30px;
    background:#fff;
    display:flex;
    flex-direction:column;
    .title-with-icon{
        display:flex;
        align-items:center;
        column-gap:6px;
        color:#1a1a1a;
        font-size:18px;
        font-weight:bold;
        margin-bottom:13px;
        .icon{
            width:36px;
            height:36px;
        }
    }
    .title-no-icon{
        color:#1a1a1a;
        font-size:18px;
        font-weight:bold;
        margin-bottom: 20px;
    }
    .account-preview-box{
        width:100%;
        background:#fff7f7;
        border-radius:8px;
        padding:30px 40px;
        display:flex;
        flex-direction:column;
        .balance-item-box{
            width:100%;
            display:flex;
            column-gap:180px;
            .balance-item{
                display:flex;
                flex-direction:column;
                .item-title{
                    color:#666;
                    font-size:14px;
                    margin-bottom:16px;
                }
                .item-value{
                    color:#1a1a1a;
                    font-size:24px;
                    font-weight:bold;
                    margin-bottom:4px;
                }
                .item-tips{
                    color:#999;
                    font-size:12px;
                    margin-bottom:32px;
                    span{
                        color:#0d99ff;
                        font-size:12px;
                        cursor:pointer;
                    }
                }
            }
        }
    }
    .account-box{
        width:100%;
        display:flex;
        column-gap:20px;
        margin-top:24px;
        .account-item{
            flex:1;
            border:1px solid #e3e3e3;
            border-radius:8px;
            padding:30px 32px 30px 40px;
            display:flex;
            flex-direction:column;
            .item-title-box{
                width:100%;
                display:flex;
                align-items:center;
                justify-content:space-between;
                .item-title{
                    color:#333;
                    font-size:18px;
                    font-weight:bold;
                }
                .item-btn{
                    display:flex;
                    align-items:center;
                    column-gap:24px;
                    color:#666;
                    font-size:14px;
                    span{
                        cursor:pointer;
                    }
                }
            }
            .item-sub-title{
                color:#666;
                font-size:14px;
                margin-top:20px;
            }
            .item-money{
                color:#1a1a1a;
                font-size:24px;
                font-weight:bold;
                margin-top:16px;
            }
            .btn-box{
                display:flex;
                align-items:center;
                column-gap:10px;
                margin-top:32px;
                .recharge-btn{
                    width:92px;
                    height:40px;
                    border-radius:4px;
                    background:#ff5967;
                    color:#fff;
                    font-size:14px;
                    font-weight:bold;
                    line-height:40px;
                    text-align:center;
                    cursor:pointer;
                }
            }
        }
    }
}

.withdrawal-btn{
    width:92px;
    height:40px;
    border-radius:4px;
    border:1px solid #ff5967;
    line-height:40px;
    text-align:center;
    cursor:pointer;
    color:#ff5967;
    font-size:14px;
    font-weight:bold;
}
</style>